// extracted by mini-css-extract-plugin
export default {"banner":"unlicensed-component-banner_banner__HzrBy","button":"unlicensed-component-banner_button__w014R"};